declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Pushes an event to the same GTM dataLayer already wired up in
 * app/layout.tsx (GTM-NZ3CKMWM) — there is no existing trackEvent helper
 * elsewhere in the app to follow, and Firebase Analytics is initialized but
 * never actually used for events, so this is the lowest-friction way to get
 * blog engagement events into the same analytics pipeline GTM already feeds.
 * No PII is included — only content identifiers (slug, category).
 */
export function trackEvent(name: string, params: Record<string, string | number | boolean> = {}): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
}
